<template>
    <div class="dm-submission-history-widget" v-if="submission_history">
        <span
            class="d-flex align-items-center text-dark font-weight-bolder mb-2"
            >{{ translate("Submission History") }}</span
        >
        <div>
            <label>{{
                translate(
                    "Do you wish to share your Manuscript Submission History?",
                )
            }}</label>
            <p class="font-italic">
                {{
                    submission_history.share
                        ? translate("Yes")
                        : translate("No")
                }}
            </p>
        </div>
        <div v-if="submission_history.share">
            <div>
                <label>{{
                    translate(
                        "Have you submitted this Manuscript to other Companies?",
                    )
                }}</label>
                <p class="font-italic">
                    {{
                        submission_history.submitted_elsewhere
                            ? translate("Yes")
                            : translate("No")
                    }}
                </p>
            </div>
            <div>
                <label>{{
                    translate(
                        "Is it currently under submissions with anyone else?",
                    )
                }}</label>
                <p class="font-italic">
                    {{
                        submission_history.is_under_submission_elsewhere
                            ? translate("Yes")
                            : translate("No")
                    }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["submission_history"],
};
</script>
